import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { rfiSectionClient } from '../rfiSectionHooks';
/**
 * WRT-16 review → final RPCs. Each refreshes the section list (statuses), the
 * workspace (version labels) and readiness.
 */ export function useRfiAnswerReview(rfiResponseProjectId) {
    const qc = useQueryClient();
    const refresh = ()=>Promise.all([
            qc.invalidateQueries({
                queryKey: [
                    'rfi-sections',
                    rfiResponseProjectId
                ]
            }),
            qc.invalidateQueries({
                queryKey: [
                    'officeWorkspace'
                ]
            }),
            qc.invalidateQueries({
                queryKey: [
                    RFI_READINESS_KEY,
                    rfiResponseProjectId
                ]
            })
        ]);
    const requestReview = useMutation({
        mutationFn: (a)=>rfiSectionClient.requestRfiAnswerReview({
                rfiResponseProjectId,
                ...a
            }),
        onSuccess: refresh
    });
    const approve = useMutation({
        mutationFn: (a)=>rfiSectionClient.approveRfiAnswer({
                rfiResponseProjectId,
                ...a
            }),
        onSuccess: refresh
    });
    const requestChanges = useMutation({
        mutationFn: (a)=>rfiSectionClient.requestRfiAnswerChanges({
                rfiResponseProjectId,
                ...a
            }),
        onSuccess: refresh
    });
    return {
        requestReview,
        approve,
        requestChanges
    };
}
export const RFI_READINESS_KEY = 'rfi-readiness';
/** `GetRfiReadiness` (WRT-16 reads the response-document projection). */ export function useRfiReadiness(rfiResponseProjectId) {
    return useQuery({
        queryKey: [
            RFI_READINESS_KEY,
            rfiResponseProjectId
        ],
        enabled: Boolean(rfiResponseProjectId),
        staleTime: 30000,
        queryFn: ()=>rfiSectionClient.getRfiReadiness({
                rfiResponseProjectId
            })
    });
}
